type Props = {
  value: number;
};

export const ProgressLine = ({ value }: Props) => {
  return (
    <div className="bg-monochrome-400/15 w-full rounded-lg h-1 mt-1">
      <div
        style={{ width: `${value}%` }}
        className={`bg-primary-500 h-full rounded-lg`}
      />
    </div>
  );
};
